import { memo } from "react";
import { Root, Spinner } from "./RouteLoadingFallback.styles";

const RouteLoadingFallback = () => {
  return (
    <Root>
      <Spinner />
    </Root>
  );
};

export default memo(RouteLoadingFallback);
